import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-78db645c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "home-page platform-home"
};
const _hoisted_2 = {
  class: "panel inventory-panel"
};
const _hoisted_3 = {
  class: "inventory-content"
};
const _hoisted_4 = ["src", "alt"];
const _hoisted_5 = {
  class: "stage-copy"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  class: "rate first-rate"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "测试通过率", -1));
const _hoisted_9 = {
  class: "rate"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "已出厂占比", -1));
const _hoisted_11 = {
  class: "rate-blue"
};
const _hoisted_12 = {
  class: "summary-row"
};
const _hoisted_13 = ["src", "alt"];
const _hoisted_14 = {
  class: "summary-text"
};
const _hoisted_15 = {
  class: "summary-label"
};
const _hoisted_16 = {
  key: 0,
  class: "summary-note"
};
const _hoisted_17 = {
  class: "charts-row"
};
const _hoisted_18 = {
  class: "panel trend-panel"
};
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "panel-title"
}, "设备生产与出厂趋势", -1));
const _hoisted_20 = {
  class: "panel distribution-panel"
};
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "panel-title"
}, "告警分类", -1));
const _hoisted_22 = {
  class: "category-charts"
};
const _hoisted_23 = {
  class: "category-chart-wrap"
};
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "category-chart-title"
}, "告警类型", -1));
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "category-divider"
}, null, -1));
const _hoisted_26 = {
  class: "category-chart-wrap"
};
const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "category-chart-title"
}, "告警级别", -1));
const _hoisted_28 = {
  class: "bottom-row"
};
const _hoisted_29 = {
  class: "panel tenant-panel"
};
const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "panel-title"
}, "租户运行概览", -1));
const _hoisted_31 = {
  class: "panel alarm-panel"
};
const _hoisted_32 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "panel-title"
}, "平台告警概览", -1));
const _hoisted_33 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "alarm-grid alarm-table-head"
}, [/*#__PURE__*/_createElementVNode("span", null, "租户名称"), /*#__PURE__*/_createElementVNode("span", null, "执行器编码"), /*#__PURE__*/_createElementVNode("span", null, "告警时间"), /*#__PURE__*/_createElementVNode("span", null, "告警内容")], -1));
const _hoisted_34 = {
  class: "alarm-list"
};
const _hoisted_35 = {
  class: "alarm-cell"
};
const _hoisted_36 = {
  class: "alarm-cell"
};
const _hoisted_37 = {
  class: "alarm-cell"
};
const _hoisted_38 = {
  class: "alarm-cell alarm-content-cell"
};
import { computed, nextTick, onBeforeUnmount, onMounted, reactive, ref } from 'vue';
import { ElMessage } from 'element-plus';
import * as echarts from 'echarts';
import { getPlatformAlarmOverview, getPlatformInventory, getPlatformProductionTrend, getPlatformSummary, getPlatformTenantOverview } from '@/api/homePage';
import addForTesting from '@/assets/img/addForTesting.png';
import testing from '@/assets/img/testing.png';
import testPassed from '@/assets/img/testPassed.png';
import shipped from '@/assets/img/Shipped.png';
import iconZh from '@/assets/img/icon-zuhu.png';
import iconZc from '@/assets/img/icon-zc.png';
import iconZz from '@/assets/img/icon-zz.png';
import iconZx from '@/assets/img/icon-zx.png';
import iconLx from '@/assets/img/icon-lx.png';
import iconGj from '@/assets/img/icon-gj.png';
import iconJt from '@/assets/img/icon-jt.png';
export default {
  __name: 'index',
  setup(__props) {
    const loading = ref(false);
    const inventory = reactive({});
    const summary = reactive({});
    const productionTrend = ref([]);
    const tenantOverview = ref([]);
    const alarmOverview = reactive({
      latest: []
    });
    const productionChart = ref(null);
    const alarmTypeChart = ref(null);
    const alarmLevelChart = ref(null);
    let productionInstance;
    let alarmTypeInstance;
    let alarmLevelInstance;
    let isPageMounted = false;
    const inventoryStages = computed(() => [{
      key: 'pendingTest',
      label: '新增待测试',
      note: '装配完成',
      icon: addForTesting,
      color: 'blue'
    }, {
      key: 'testing',
      label: '测试进行中',
      note: '正在执行测试',
      icon: testing,
      color: 'orange'
    }, {
      key: 'testPassed',
      label: '合格待出厂',
      note: '测试合格',
      icon: testPassed,
      color: 'green'
    }, {
      key: 'shipped',
      label: '已出厂',
      note: '完成出厂',
      icon: shipped,
      color: 'purple'
    }]);
    const summaryCards = [{
      key: 'tenantCount',
      label: '租户总数',
      icon: iconZh,
      color: 'blue'
    }, {
      key: 'actuatorCount',
      label: '执行器总数',
      icon: iconZz,
      color: 'blue'
    }, {
      key: 'onlineCount',
      label: '在线数量',
      icon: iconZx,
      color: 'green'
    }, {
      key: 'offlineCount',
      label: '离线数量',
      icon: iconLx,
      color: 'orange'
    }, {
      key: 'alarmCount',
      label: '告警数量',
      icon: iconGj,
      color: 'red'
    }, {
      key: 'normalCount',
      label: '正常数量',
      icon: iconZc,
      color: 'green',
      note: '在线且无告警'
    }];
    const number = value => Number(value || 0).toLocaleString();
    const tenantStatus = row => {
      const actuatorCount = Number(row?.actuatorCount || 0);
      if (actuatorCount === 0) return '无设备';
      return Number(row?.normalCount || 0) === actuatorCount ? '正常' : '关注';
    };
    const tenantStatusType = row => {
      const status = tenantStatus(row);
      return status === '正常' ? 'success' : status === '关注' ? 'warning' : 'info';
    };
    const categoryName = name => ({
      control: '控制类告警',
      power: '电源类告警',
      detector: '探测类告警',
      comm: '通信类告警',
      valve: '阀门类告警',
      communication: '通信类告警',
      other: '其他告警'
    })[name] || name || '其他告警';
    const categoryColors = ['#f43f3f', '#ff9800', '#287fea', '#16ae6d', '#8b5cf6'];
    const setCategoryPie = (instance, rows, formatName, totalLabel) => {
      const data = (rows || []).map((item, index) => ({
        value: item.value || 0,
        name: formatName(item.name),
        itemStyle: {
          color: categoryColors[index % categoryColors.length]
        }
      }));
      const total = data.reduce((sum, item) => sum + Number(item.value || 0), 0);
      instance.setOption({
        tooltip: {
          trigger: 'item',
          backgroundColor: 'rgba(255,255,255,.96)',
          borderColor: '#e8edf3',
          borderWidth: 1,
          textStyle: {
            color: '#334155',
            fontSize: 12
          },
          formatter: p => `<span style="display:inline-block;width:8px;height:8px;border-radius:50%;background:${p.color};margin-right:6px;"></span>${p.name}<br/><span style="font-weight:700;font-size:15px;">${p.value}</span> <span style="color:#94a3b8;">(${p.percent}%)</span>`
        },
        legend: {
          type: 'scroll',
          bottom: 0,
          left: 'center',
          itemWidth: 8,
          itemHeight: 8,
          itemGap: 10,
          icon: 'circle',
          textStyle: {
            fontSize: 11,
            color: '#64748b',
            padding: [0, 0, 0, 2]
          }
        },
        graphic: [{
          type: 'text',
          left: 'center',
          top: '34%',
          style: {
            text: `${total}`,
            textAlign: 'center',
            fontSize: 22,
            fontWeight: 800,
            lineHeight: 26,
            fill: '#1e293b'
          }
        }, {
          type: 'text',
          left: 'center',
          top: '48%',
          style: {
            text: totalLabel,
            textAlign: 'center',
            fontSize: 11,
            fontWeight: 400,
            fill: '#94a3b8'
          }
        }],
        series: [{
          type: 'pie',
          radius: ['36%', '72%'],
          center: ['50%', '42%'],
          padAngle: 2,
          itemStyle: {
            borderRadius: 4,
            borderColor: '#fff',
            borderWidth: 2
          },
          emphasis: {
            scaleSize: 6,
            itemStyle: {
              shadowBlur: 12,
              shadowColor: 'rgba(0,0,0,.15)'
            }
          },
          label: {
            show: false
          },
          data
        }]
      });
    };
    const renderCharts = () => nextTick(() => {
      if (!isPageMounted || !productionChart.value || !alarmTypeChart.value || !alarmLevelChart.value) return;
      productionInstance?.dispose();
      alarmTypeInstance?.dispose();
      alarmLevelInstance?.dispose();
      productionInstance = echarts.init(productionChart.value);
      alarmTypeInstance = echarts.init(alarmTypeChart.value);
      alarmLevelInstance = echarts.init(alarmLevelChart.value);
      productionInstance.setOption({
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          top: 0
        },
        grid: {
          left: 42,
          right: 20,
          top: 42,
          bottom: 28
        },
        xAxis: {
          type: 'category',
          data: productionTrend.value.map(item => item.label)
        },
        yAxis: {
          type: 'value'
        },
        series: [{
          name: '新增设备',
          type: 'bar',
          barWidth: 24,
          data: productionTrend.value.map(item => item.addedCount),
          itemStyle: {
            color: '#2f89ed',
            borderRadius: [4, 4, 0, 0]
          }
        }, {
          name: '测试合格',
          type: 'line',
          smooth: true,
          data: productionTrend.value.map(item => item.passedCount),
          itemStyle: {
            color: '#15b86a'
          }
        }, {
          name: '已出厂',
          type: 'line',
          smooth: true,
          data: productionTrend.value.map(item => item.shippedCount),
          itemStyle: {
            color: '#ff8a00'
          }
        }]
      });
      setCategoryPie(alarmTypeInstance, alarmOverview.alarmTypes, categoryName, '类型告警');
      setCategoryPie(alarmLevelInstance, alarmOverview.alarmLevels, name => name || '未配置级别', '级别告警');
    });
    const loadData = async () => {
      loading.value = true;
      try {
        const [inventoryRes, summaryRes, trendRes, tenantRes, alarmRes] = await Promise.all([getPlatformInventory(), getPlatformSummary(), getPlatformProductionTrend(), getPlatformTenantOverview(), getPlatformAlarmOverview()]);
        if (!isPageMounted) return;
        Object.assign(inventory, inventoryRes.data || {});
        Object.assign(summary, summaryRes.data || {});
        Object.assign(alarmOverview, alarmRes.data || {});
        productionTrend.value = trendRes.data || [];
        tenantOverview.value = tenantRes.data || [];
        renderCharts();
      } catch (error) {
        if (isPageMounted) ElMessage.error('首页数据加载失败');
      } finally {
        if (isPageMounted) loading.value = false;
      }
    };
    const resize = () => {
      productionInstance?.resize();
      alarmTypeInstance?.resize();
      alarmLevelInstance?.resize();
    };
    onMounted(() => {
      isPageMounted = true;
      loadData();
      window.addEventListener('resize', resize);
    });
    onBeforeUnmount(() => {
      isPageMounted = false;
      window.removeEventListener('resize', resize);
      productionInstance?.dispose();
      alarmTypeInstance?.dispose();
      alarmLevelInstance?.dispose();
    });
    return (_ctx, _cache) => {
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_tag = _resolveComponent("el-tag");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      const _component_el_empty = _resolveComponent("el-empty");
      const _directive_loading = _resolveDirective("loading");
      return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("section", _hoisted_2, [_createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(inventoryStages), (stage, index) => {
        return _openBlock(), _createElementBlock(_Fragment, {
          key: stage.key
        }, [_createElementVNode("div", {
          class: _normalizeClass(["inventory-stage", 'stage-' + stage.color])
        }, [_createElementVNode("img", {
          src: stage.icon,
          alt: stage.label
        }, null, 8, _hoisted_4), _createElementVNode("div", _hoisted_5, [_createElementVNode("span", null, _toDisplayString(stage.label), 1), _createElementVNode("strong", null, _toDisplayString(number(inventory[stage.key])), 1), _createElementVNode("small", null, _toDisplayString(stage.note), 1)])], 2), index < _unref(inventoryStages).length - 1 ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: _unref(iconJt),
          class: "stage-arrow",
          alt: "箭头"
        }, null, 8, _hoisted_6)) : _createCommentVNode("", true)], 64);
      }), 128)), _createElementVNode("div", _hoisted_7, [_hoisted_8, _createElementVNode("strong", null, _toDisplayString(inventory.testPassRate || 0) + "%", 1)]), _createElementVNode("div", _hoisted_9, [_hoisted_10, _createElementVNode("strong", _hoisted_11, _toDisplayString(inventory.shipmentRate || 0) + "%", 1)])])]), _createElementVNode("section", _hoisted_12, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(summaryCards, item => {
        return _createElementVNode("div", {
          key: item.key,
          class: _normalizeClass(["summary-card", 'card-' + item.color])
        }, [_createElementVNode("img", {
          src: item.icon,
          alt: item.label,
          class: "summary-icon"
        }, null, 8, _hoisted_13), _createElementVNode("div", _hoisted_14, [_createElementVNode("span", _hoisted_15, _toDisplayString(item.label), 1), _createElementVNode("strong", {
          class: _normalizeClass(["summary-value", 'val-' + item.color])
        }, _toDisplayString(number(summary[item.key])), 3), item.note ? (_openBlock(), _createElementBlock("small", _hoisted_16, _toDisplayString(item.note), 1)) : _createCommentVNode("", true)])], 2);
      }), 64))]), _createElementVNode("section", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_hoisted_19, _createElementVNode("div", {
        ref_key: "productionChart",
        ref: productionChart,
        class: "chart"
      }, null, 512)]), _createElementVNode("div", _hoisted_20, [_hoisted_21, _createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [_hoisted_24, _createElementVNode("div", {
        ref_key: "alarmTypeChart",
        ref: alarmTypeChart,
        class: "category-chart"
      }, null, 512)]), _hoisted_25, _createElementVNode("div", _hoisted_26, [_hoisted_27, _createElementVNode("div", {
        ref_key: "alarmLevelChart",
        ref: alarmLevelChart,
        class: "category-chart"
      }, null, 512)])])])]), _createElementVNode("section", _hoisted_28, [_createElementVNode("div", _hoisted_29, [_hoisted_30, _createVNode(_component_el_table, {
        data: tenantOverview.value,
        height: "calc(100% - 32px)",
        size: "small",
        stripe: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          prop: "tenantName",
          label: "租户名称",
          "min-width": "190",
          "show-overflow-tooltip": ""
        }), _createVNode(_component_el_table_column, {
          prop: "actuatorCount",
          label: "执行器数",
          align: "center"
        }), _createVNode(_component_el_table_column, {
          prop: "normalCount",
          label: "正常数",
          align: "center"
        }), _createVNode(_component_el_table_column, {
          prop: "onlineCount",
          label: "在线数",
          align: "center"
        }), _createVNode(_component_el_table_column, {
          prop: "offlineCount",
          label: "离线数",
          align: "center"
        }), _createVNode(_component_el_table_column, {
          label: "在线率",
          align: "center"
        }, {
          default: _withCtx(scope => [_createTextVNode(_toDisplayString(scope.row.onlineRate || 0) + "%", 1)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "alarmCount",
          label: "告警数",
          align: "center"
        }), _createVNode(_component_el_table_column, {
          label: "运行状态",
          align: "center"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_tag, {
            type: tenantStatusType(scope.row),
            size: "small"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(tenantStatus(scope.row)), 1)]),
            _: 2
          }, 1032, ["type"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"])]), _createElementVNode("div", _hoisted_31, [_hoisted_32, _hoisted_33, _createElementVNode("div", _hoisted_34, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(alarmOverview.latest || [], alarm => {
        return _openBlock(), _createElementBlock("div", {
          key: alarm.id,
          class: "alarm-grid alarm-item"
        }, [_createVNode(_component_el_tooltip, {
          content: alarm.tenantName || '未知租户',
          placement: "top",
          "show-after": 300
        }, {
          default: _withCtx(() => [_createElementVNode("span", _hoisted_35, _toDisplayString(alarm.tenantName || '未知租户'), 1)]),
          _: 2
        }, 1032, ["content"]), _createVNode(_component_el_tooltip, {
          content: alarm.actuatorNum || '--',
          placement: "top",
          "show-after": 300
        }, {
          default: _withCtx(() => [_createElementVNode("span", _hoisted_36, _toDisplayString(alarm.actuatorNum || '--'), 1)]),
          _: 2
        }, 1032, ["content"]), _createVNode(_component_el_tooltip, {
          content: alarm.alarmTime || '--',
          placement: "top",
          "show-after": 300
        }, {
          default: _withCtx(() => [_createElementVNode("span", _hoisted_37, _toDisplayString(alarm.alarmTime || '--'), 1)]),
          _: 2
        }, 1032, ["content"]), _createVNode(_component_el_tooltip, {
          content: alarm.alarmType || '--',
          placement: "top",
          "show-after": 300
        }, {
          default: _withCtx(() => [_createElementVNode("span", _hoisted_38, _toDisplayString(alarm.alarmType || '--'), 1)]),
          _: 2
        }, 1032, ["content"])]);
      }), 128)), !(alarmOverview.latest || []).length ? (_openBlock(), _createBlock(_component_el_empty, {
        key: 0,
        description: "暂无告警",
        "image-size": 55
      })) : _createCommentVNode("", true)])])])])), [[_directive_loading, loading.value]]);
    };
  }
};